import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MUIMenu from "@mui/material/Menu";
import MUIMenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import { IconButton } from "react-native-paper";
import type { IconType } from "../..";
import { useAppTheme } from "../../useAppTheme";
import type { GetMessageActions } from "./types";

type Props = {
	messageActions: GetMessageActions;
	content?: string;
	showEmail?: boolean;
	align?:
		| "flex-start"
		| "flex-end"
		| "center"
		| "space-between"
		| "space-around"
		| "space-evenly"
		| undefined;
	runId?: string;
};

export const MessageActions = ({
	messageActions,
	align: _align = "flex-start",
	showEmail,
	content,
	runId,
}: Props) => {
	const theme = useAppTheme();
	const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorElement);

	const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorElement(event.currentTarget);
	};

	const closeMenu = () => {
		setAnchorElement(null);
	};

	return (
		<>
			<IconButton
				icon="dots-vertical"
				size={18}
				iconColor={theme.colors.onPrimaryContainer}
				style={{ margin: 0 }}
				// @ts-expect-error this is only intended for web, where it does get the proper mouse event
				onPress={openMenu}
			/>
			<MUIMenu
				anchorEl={anchorElement}
				open={open}
				onClose={closeMenu}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
			>
				{messageActions(showEmail, runId).map(
					({ icon, tooltip, handleOnPress }) => (
						<MUIMenuItem
							key={icon}
							onClick={() => {
								handleOnPress(content);
								closeMenu();
							}}
						>
							<ListItemIcon>
								{icon && (
									<Icon
										name={icon as IconType}
										color={theme.colors.onPrimaryContainer}
										size={18}
									/>
								)}
							</ListItemIcon>
							<ListItemText>{tooltip}</ListItemText>
						</MUIMenuItem>
					),
				)}
			</MUIMenu>
		</>
	);
};
